import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationScreenRoutingModule } from './notification-screen-routing.module';
import { NotificationScreenComponent } from './notification-screen.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SharedModule } from 'primeng/api';
import { PageTitleModule } from 'src/app/shared/page-title/page-title.module';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { SimplebarAngularModule } from 'simplebar-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from "primeng/editor";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    NotificationScreenComponent
  ],
  imports: [
    CommonModule,
    NotificationScreenRoutingModule,
    WidgetModule,
    SharedModule,
    PageTitleModule,
    TranslateModule,
    NgbPaginationModule,
    SweetAlert2Module,
    FormsModule,
    ReactiveFormsModule,
    SimplebarAngularModule,
    TabViewModule,
    EditorModule,
    InfiniteScrollModule]
})
export class NotificationScreenModule { }
